module.exports = __webpack_public_path__ + "static/img/19012B_2_V_20230821_fit.f02d013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19012B_2_V_20230821_fit.png
// module id = ySwd
// module chunks = 0